<div class="dt-partner-editor" (keydown)="onEditorKeydown($event)">
  <div class="dt-partner-editor__header">
    <div class="dt-partner-editor__carrier">{{ sourceLabel }}</div>
    <button type="button" class="dt-partner-editor__clear" (click)="clearValue()">Clear</button>
  </div>

  <label class="dt-partner-editor__field">
    <span class="dt-partner-editor__label">Partner carrier</span>
    <ng-select
      class="dt-partner-ng-select"
      [items]="partners"
      [formControl]="partnerControl"
      [clearable]="true"
      [searchable]="false"
      [loading]="loadingPartners || savingPartner"
      placeholder="Select partner carrier"
      (change)="onPartnerSelected($event)"
      (clear)="clearValue()"
    >
      <ng-template ng-label-tmp let-item="item">
        {{ optionLabel(item) }}
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <span class="dt-partner-editor__name">{{ optionLabel(item) }}</span>
        <span *ngIf="optionMeta(item)" class="dt-partner-editor__meta">{{ optionMeta(item) }}</span>
      </ng-template>
    </ng-select>
  </label>

  <div class="dt-partner-editor__actions">
    <button type="button" class="dt-partner-editor__search-button" (click)="openSearch()" [disabled]="savingPartner">
      Search
    </button>
    <span *ngIf="loadingPartners" class="dt-partner-editor__state">Loading...</span>
  </div>

  <div *ngIf="showSearch" class="dt-partner-editor__search-panel">
    <label class="dt-partner-editor__field">
      <span class="dt-partner-editor__label">Search carriers</span>
      <ng-select
        #contactSearch
        class="dt-partner-ng-select"
        [items]="contactOptions"
        [formControl]="searchControl"
        [clearable]="true"
        [searchable]="true"
        [loading]="searchingContacts || savingPartner"
        [searchFn]="serverSearchFilter"
        bindLabel="contact_organization"
        placeholder="Search name, SCAC, MC, or DOT"
        notFoundText="No matches"
        typeToSearchText="Search name, SCAC, MC, or DOT"
        (search)="onContactSearch($event)"
        (change)="onContactSelected($event)"
        (clear)="contactOptions = []"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ optionLabel(item) }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="dt-partner-editor__name">{{ optionLabel(item) }}</span>
          <span class="dt-partner-editor__meta">
            <span *ngIf="!isExistingPartner(item)" class="dt-partner-editor__badge">{{ hasSourceCarrier ? 'Add' : 'Use' }}</span>
            {{ optionMeta(item) }}
          </span>
        </ng-template>
      </ng-select>
    </label>

    <div *ngIf="savingPartner" class="dt-partner-editor__state">Adding...</div>
  </div>

  <div *ngIf="errorMessage" class="dt-partner-editor__error">{{ errorMessage }}</div>

  <div class="dt-partner-editor__footer">
    <button type="button" class="dt-partner-editor__cancel" (click)="cancel()">Cancel</button>
  </div>
</div>
